module.exports = __webpack_public_path__ + "media/images/sp/specials/common/benefit/benefit_dress-80abadf570976967608f942e64d910ca.webp";